export class OrderRefundSearchRequest {
  constructor(
    public ids: string[],
    public clientId: string,
    public orderId: string,
    public offset: number,
    public limit: number,
  ) {}
}
